export const TEAM_USER_TYPES = {
  CONTRIBUTOR: 'CONTRIBUTOR',
  MANAGER: 'MANAGER',
};
